<template>
  <div class="home-page">
    <!-- 搜索行 -->
    <div class="search-row">
      <div class="search-box">
        <van-icon name="search" size="20" color="#999" />
        <input
          v-model="searchText"
          class="search-input"
          type="text"
          placeholder="请输入企业或岗位名称"
        />
        <van-icon v-if="searchText" name="clear" size="20" color="#c8c9cc" class="search-clear" @click="clearSearch" />
        <van-button class="search-btn" size="small" round @click="onSearch">搜索</van-button>
      </div>
    </div>

    <!-- 筛选栏 -->
    <div class="filter-bar">
      <div
        v-for="(filter, i) in filters"
        :key="i"
        class="filter-item"
        :class="{ active: filter.active }"
        @click="onFilterClick(i)"
      >
        <span>{{ filter.text }}</span>
        <!-- 排序项图标随排序状态切换：倒序箭头向上 -->
        <van-icon :name="i === 2 && queryParams.order === 2 ? 'arrow-up' : 'arrow-down'" size="17" class="arrow-icon" />
      </div>
    </div>

    <!-- 任务列表 -->
    <div class="job-list">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        :immediate-check="false"
        @load="getList"
      >
      <div v-for="item in jobList" :key="item.id" class="job-card">
        <div class="job-title">{{ item.title }}</div>
        <!-- 薪酬单独一行（job-body 上方），flex:1 右对齐 -->
        <div v-if="item.salaryRange" class="salary-row">
          <div class="salary-text">{{ item.salaryRange }}元</div>
        </div>
        <div class="job-body">
          <div class="job-info">
            <div class="info-line"><span class="row-label">企业：</span><span class="row-value">{{ item.company }}</span></div>
            <div class="info-line"><span class="row-label">时间：</span><span class="row-value">{{ item.dateRange }}</span></div>
            <div class="info-line"><span class="row-label">招募：</span><span class="row-value">{{ item.recruitCount }}人</span></div>
          </div>
          <!-- 右上角：结算方式标签 -->
          <div class="job-side">
            <div class="settle-tag">{{ item.salaryTips || '' }}</div>
          </div>
        </div>
        <div class="job-action">
          <div class="job-location">地点：{{ item.location }}</div>
          <van-button type="info" size="small" plain @click="viewDetail(item)">查看详情</van-button>
        </div>
      </div>
      </van-list>

      <!-- 空状态 -->
      <van-empty description="暂无数据" v-if="finished && !jobList.length" />
    </div>

    <!-- 地区三级联动选择（省市区） -->
    <van-popup v-model="showAreaPicker" position="bottom" round>
      <div class="area-reset" @click="resetArea">重置地区</div>
      <van-area
        title="选择地区"
        :area-list="areaList"
        @confirm="onAreaConfirm"
        @cancel="onAreaCancel"
      />
    </van-popup>

    <!-- 经验要求选择 -->
    <van-popup v-model="showExperiencePicker" position="bottom" round>
      <van-picker
        show-toolbar
        title="经验要求"
        :columns="experienceOptions"
        @confirm="onExperienceConfirm"
        @cancel="showExperiencePicker = false"
      />
    </van-popup>

    <footer-menu></footer-menu>
  </div>
</template>
<script>
import { NavBar, Button, Icon, Area } from 'vant'
import { areaList } from '@vant/area-data'
import footerMenu from '@/components/footer/FooterMenu'
import requestHomeAPI from '@/axios/HomeApi'

export default {
  name: 'Home',
  components: {
    [NavBar.name]: NavBar,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Area.name]: Area,
    footerMenu
  },
  data () {
    return {
      // 搜索关键字
      searchText: '',
      // 查询参数（省市区编码待筛选功能接入后填充）
      queryParams: {
        provinceCode: null, // 省
        cityCode: null, // 市
        districtCode: null, // 区县
        experience: 0, // 经验：0不限 1:1-3年 2:3-5年 3:5-10年 4:10年以上
        order: 1, // 排序：1顺序 2倒序
        pageNum: 1,
        pageSize: 10
      },
      // 筛选栏选项，active 为激活态（蓝色）
      filters: [
        { text: '选择地区', active: true },
        { text: '经验要求', active: false },
        { text: '排序最新', active: false }
      ],
      // 地区三级联动选择器（省市区）
      showAreaPicker: false,
      areaList,
      // 经验要求选项（0不限 1:1-3年 2:3-5年 3:5-10年 4:10年以上）
      showExperiencePicker: false,
      experienceOptions: [
        { text: '不限', value: 0 },
        { text: '1-3年', value: 1 },
        { text: '3-5年', value: 2 },
        { text: '5-10年', value: 3 },
        { text: '10年以上', value: 4 }
      ],
      // 任务列表数据（接口返回后填充）
      jobList: [],
      // 列表加载状态（van-list 分页）
      loading: false,
      finished: false,
      total: 0
    }
  },
  created () {
    this.resetList()
  },
  methods: {
    // 获取首页项目列表（van-list 触底加载，一页10条）
    getList () {
      this.loading = true
      const { provinceCode, cityCode, districtCode, experience, order, pageNum, pageSize } = this.queryParams
      requestHomeAPI.htIndex({
        projectName: this.searchText, // 搜索关键字作为项目名称
        provinceCode,
        cityCode,
        districtCode,
        experience,
        order,
        pageNum,
        pageSize
      }).then(res => {
        if (res.data.code === '0000') {
          const data = res.data.data || {}
          const rows = (data.rows || []).map(row => this.formatJob(row))
          // 追加到列表末尾（加载更多）
          this.jobList = this.jobList.concat(rows)
          console.log('打印结果', this.jobList)

          this.total = data.total || 0
          this.queryParams.pageNum++
          // 结束条件：数据到齐，或本页不足一页（服务端 total 与实际条数不一致时防止无限翻页）
          if (this.jobList.length >= this.total || rows.length < this.queryParams.pageSize) {
            this.finished = true
          }
        } else {
          this.finished = true
          this.$notify({ type: 'danger', message: res.data.message })
        }
      }).catch(() => {
        this.finished = true
        this.$notify({ type: 'danger', message: '加载失败，请重试' })
      }).finally(() => {
        this.loading = false
      })
    },
    // 重置列表并重新加载（筛选/搜索条件变化后调用）
    resetList () {
      this.jobList = []
      this.queryParams.pageNum = 1
      this.finished = false
      this.getList()
    },
    // 接口字段 → 卡片展示字段
    formatJob (row) {
      return {
        id: row.id,
        projectId: row.projectId,
        title: row.projectName,
        company: row.merName,
        location: this.formatLocation(row),
        recruitCount: row.recruitCount,
        signCount: row.signCount,
        salaryRange: row.salaryRange,
        salaryTips: row.salaryTips || '',
        dateRange: row.createTime && row.endTime ? `${row.createTime} - ${row.endTime}` : ''
      }
    },
    // 省市区拼接，直辖市（省市同名）去重
    formatLocation (row) {
      const parts = [row.provinceName, row.cityName, row.districtName]
      return parts
        .filter((part, i) => part && (i === 0 || part !== parts[i - 1]))
        .join('')
    },
    // 筛选栏点击
    onFilterClick (i) {
      // 第一个筛选：地区三级联动选择
      if (i === 0) {
        this.showAreaPicker = true
      } else if (i === 1) {
        // 第二个筛选：经验要求
        this.showExperiencePicker = true
      } else if (i === 2) {
        // 第三个筛选：点击切换排序（1顺序 2倒序）
        this.toggleSort()
      }
    },
    // 地区选择确认（values: 省、市、区县 三级 [{code, name}]）
    onAreaConfirm (values) {
      const [province, city, district] = values
      this.queryParams.provinceCode = Number(province.code)
      this.queryParams.cityCode = Number(city.code)
      this.queryParams.districtCode = Number(district.code)
      // 筛选栏展示选中的区县名称
      this.filters[0].text = district.name
      this.showAreaPicker = false
      // 按新选的地区重新查询
      this.resetList()
    },
    onAreaCancel () {
      this.showAreaPicker = false
    },
    // 清空搜索关键字并重新加载
    clearSearch () {
      this.searchText = ''
      this.resetList()
    },
    // 重置地区筛选（省市区编码全部置空）
    resetArea () {
      this.queryParams.provinceCode = null
      this.queryParams.cityCode = null
      this.queryParams.districtCode = null
      this.filters[0].text = '选择地区'
      this.showAreaPicker = false
      this.resetList()
    },
    // 经验要求确认
    onExperienceConfirm (option) {
      // 传数字给后台
      this.queryParams.experience = option.value
      // 筛选栏展示选中的选项文字
      this.filters[1].text = option.text
      this.showExperiencePicker = false
      // 按新条件重新查询
      this.resetList()
    },
    // 点击切换排序（1顺序 2倒序）
    toggleSort () {
      const next = this.queryParams.order === 2 ? 1 : 2
      this.queryParams.order = next
      // 筛选栏展示当前排序方式
      this.filters[2].text = next === 1 ? '排序最新' : '排序倒序'
      // 按新排序重新查询
      this.resetList()
    },
    onSearch () {
      this.resetList()
    },
    viewDetail (item) {
      // 跳转到任务详情页，携带列表已有信息
      console.log('传递参数', item.projectId)
      this.$router.push({
        path: '/taskDetail',
        query: {
          projectId: item.projectId
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
/*
 * 注意：项目 postcss 按 750 设计稿宽度将 px 自动转成 vw（src 代码），
 * 即源码数值是设计稿坐标，实际渲染大小 = 数值 ÷ 2。
 * 因此字号/间距请按“想要的视觉大小 × 2”书写；
 * van-icon 等组件 size 属性是内联样式，不参与转换，直接写视觉大小即可。
 */
.home-page {
  min-height: 100%;
  background: #f5f5f5;
}

/* 搜索行 */
.search-row {
  padding: 20px 32px;
  background: #fff;

  /* 胶囊形搜索容器 */
  .search-box {
    display: flex;
    align-items: center;
    height: 96px;
    padding: 0 16px 0 24px;
    background: #f5f5f5;
    border-radius: 999px;

    .search-input {
      flex: 1;
      border: none;
      outline: none;
      background: transparent;
      margin-left: 16px;
      font-size: 30px;
      color: #323233;

      &::placeholder {
        color: #c8c9cc;
      }
    }

    /* 清空搜索图标 */
    .search-clear {
      margin: 0 16px 0 8px;
    }

    /* 红色胶囊搜索按钮 */
    .search-btn.van-button {
      flex-shrink: 0;
      height: 80px;
      line-height: 80px;
      padding: 0 40px;
      font-size: 30px;
      border: none;
      border-radius: 999px;
      color: #e92504;
      border: 1px solid #e92504;
    }
  }
}

/* 地区弹层里的重置按钮 */
.area-reset {
  padding: 24px 32px 8px;
  background: #fff;
  font-size: 30px;
  color: #e92504;
  text-align: right;
}

/* 筛选栏 */
.filter-bar {
  display: flex;
  background: #fff;

  .filter-item {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 80px;
    font-size: 32px;
    color: #333;

    &.active {
      color: #e92504;
    }

    .arrow-icon {
      margin-left: 2px;
    }
  }
}

/* 任务卡片 */
.job-list {
  padding: 20px;
}

.job-card {
  padding: 28px 32px;
  background: #fff;
  border-radius: 16px;
  margin-bottom: 20px;
  text-align: left;

  .job-title {
    font-size: 38px;
    font-weight: 600;
    color: #323233;
    margin-bottom: 20px;
  }

  /* 薪酬：单独一行，flex:1 右对齐 */
  .salary-row {
    display: flex;
    margin-bottom: 4px;

    .salary-text {
      flex: 1;
      text-align: right;
      font-size: 36px; /* 比信息行稍大 */
      font-weight: 600;
      color: #e92504;
      white-space: nowrap;
    }
  }

  /* 两列：左侧信息（左对齐），右上角结算标签 */
  .job-body {
    display: flex;
    text-align: left;

    .job-info {
      flex: 1;
      min-width: 0;

      .info-line {
        font-size: 28px;
        color: #999;
        line-height: 48px;

        /* 左侧标签浅色，右侧内容深色 */
        .row-label {
          color: #999;
        }

        .row-value {
          color: #323233;
        }
      }
    }

    /* 右上角：结算方式边框标签 */
    .job-side {
      flex-shrink: 0;
      margin-left: 10px;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      width: 120px;

      .settle-tag {
        font-size: 24px;
        color: #666;
        padding: 4px 12px;
        border: 1px solid #dcdee0;
        border-radius: 8px; /* 小圆角 */
        white-space: nowrap;
      }
    }
  }

  /* 按钮区：左侧地点，右侧查看详情按钮 */
  .job-action {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    /* 地点：稍黑加粗 */
    .job-location {
      font-size: 28px;
      font-weight: 600;
      color: #323233;
    }

    /* 「查看详情」按钮文字随页面统一增大 5px */
    .van-button {
      font-size: 34px;
      height: 76px;
      padding: 0 24px;
      border-radius: 16px;
      background: rgba(255, 255, 255, 0.6); /* 透明白色背景 */
      border-color: #e92504; /* 红色边框 */
      color: #e92504; /* 红色文字 */
    }
  }
}
</style>
